export const mgPlatformCloseLightIcon = {
  data: `<svg viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.17004 0.839844L9.17004 8.83984" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round"/><path d="M9.17004 0.839844L1.17004 8.83984" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round"/></svg>`,
  name: 'close-light'
}
